export const PageDataState = {
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        register_type: {
            type: 'text',
            id: 'register_type',
            label: 'ประเภทผู้ลงทะเบียน',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },

        /* operator section */
            /* ยังไม่เปิดให้กรอกเนื่องจาก ก่ีสมัครในรูปแบบผู้ประกอบการยังไม่รองรับ */
            operator_name: {
                type: 'text',
                id: 'operator_name',
                label: 'ผู้ประกอบการ',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                    maxLength: 250
                },
                error: { status: null, msg: '' }
            },        
            benefits_id: {
                type: 'text',
                id: 'benefits_id',
                label: 'ประเภทสิทธิประโยชน์',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                },
                error: { status: null, msg: '' }
            },
            target_industries_id: {
                type: 'text',
                id: 'target_industries_id',
                label: 'อุตสาหกรรมเป้าหมาย',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                },
                error: { status: null, msg: '' }
            },
            executive: {
                type: 'text',
                id: 'executive',
                label: 'ผู้บริหาร',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                    minLength: 3,
                    maxLength: 250
                },
                error: { status: null, msg: '' }
            },
            position: {
                type: 'text',
                id: 'position',
                label: 'ตำแหน่ง',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                },
                error: { status: null, msg: '' }
            },
            coordinator_name: {
                type: 'text',
                id: 'coordinator_name',
                label: 'ผู้ประสานงาน',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                    minLength: 3,
                    maxLength: 250
                },
                error: { status: null, msg: '' }
            },
            coordinator_phone_number: {
                type: 'text',
                id: 'coordinator_phone_number',
                label: 'เบอร์โทรติดต่อผู้ประสานงาน',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                    minLength: 9,
                    maxLength: 250
                },
                error: { status: null, msg: '' }
            },
            enterprise_contact: {
                type: 'text',
                id: 'enterprise_contact',
                label: 'หมายเลขโทรศัพท์ผู้ประกอบการ',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                    minLength: 9,
                    maxLength: 250
                },
                error: { status: null, msg: '' }
            },
            fax: {
                type: 'text',
                id: 'fax',
                label: 'เบอร์โทรสาร',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                },
                error: { status: null, msg: '' }
            },            
            location: {
                type: 'text',
                id: 'location',
                label: 'สถานที่ดำเนินกิจการ',
                value: '',
                validator: {
                    type: 'text',
                    required: false,
                    maxLength: 250
                },
                error: { status: null, msg: '' }
            },
            province_id: {
            type: 'text',
            id: 'province_id',
            label: 'จังหวัด',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 2,
                maxLength: 2
            },
            error: { status: null, msg: '' }
        },
        district_id: {
            type: 'text',
            id: 'district_id',
            label: 'เขต / อำเภอ',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 4,
                maxLength: 4
            },
            error: { status: null, msg: '' }
        },
        subdistrict_id: {
            type: 'text',
            id: 'subdistrict_id',
            label: 'แขวง / ตำบล',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 6,
                maxLength: 6
            },
            error: { status: null, msg: '' }
        },
        /*  end operator section */

        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ชื่อ-นามสกุลผู้ใช้',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        username: {
            type: 'text',
            id: 'username',
            label: 'ชื่อบัญชีผู้ใช้',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        password: {
            type: 'text',
            id: 'password',
            label: 'รหัสผ่าน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 4,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },

        contact: {
            type: 'text',
            id: 'contact',
            label: 'เบอร์ติดต่อ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 9,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        email: {
            type: 'text',
            id: 'email',
            label: 'อีเมล',
            value: '',
            validator: {
                type: 'email',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        //ยังไม่เปิดให้กรอกเนื่องจาก รายชื่อตำแหน่งงานในฐานข้อมูลยังไม่รองรับ
        // position_id: {
        //     type: 'text',
        //     id: 'position_id',
        //     label: 'ตำแหน่ง',
        //     value: '',
        //     validator: {
        //         type: 'text',
        //         required: false,
        //         minLength: 5,
        //         maxLength: 250
        //     },
        //     error: { status: null, msg: '' }
        // },
        profile_img: {
            type: 'file',
            id: 'profile_img',
            label: 'รูปภาพผู้ใช้งาน',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
        register_date: {
            type: 'text',
            id: 'register_date',
            label: 'วันที่ลงทะเบียน',
            value: '',
            validator: {
                type: 'date',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}